
/* eslint-disable */

$('.js-view-more').on('click', function() {
    $(this).closest('.js-hide-show').find('.hide-content').slideToggle();
    $(this).toggleClass('active');
});

